/* Lynexas — scroll-reveal: hien dan tung section khi cuon toi. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var targets = document.querySelectorAll('main .shopify-section');
  if (!targets.length) return;

  document.documentElement.classList.add('lyx-animate');

  if (!('IntersectionObserver' in window)) {
    targets.forEach(function (t) { t.classList.add('lyx-in'); });
    return;
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('lyx-in');
          io.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
  );

  targets.forEach(function (t) { io.observe(t); });
})();

/* Muc menu CHA (co menu con, vi du "Shop by Category"): bam vao chu KHONG dieu
   huong di dau, chi mo/dong menu con — giong mau weeklydealhub (Dawn dung
   <details>/<summary>). Horizon render <a href> that nen mac dinh se dieu huong;
   o day chan lai va bam ho vao nut mui ten ben canh. */
(function () {
  document.addEventListener('click', function (event) {
    var link = event.target.closest('.menu-list__trigger .menu-list__link');
    if (!link) return;

    var trigger = link.closest('.menu-list__trigger');
    var disclosure = trigger && trigger.querySelector('.menu-list__disclosure');
    if (!disclosure) return; // khong co menu con -> de dieu huong binh thuong

    event.preventDefault();
    disclosure.click();
  });

  /* Da bo hover-open (xem blocks/_header-menu.liquid) nen submenu chi dong khi
     roi focus. Them: bam ra ngoai hoac nhan Esc thi dong lai. */
  function closeOpenSubmenus(exceptItem) {
    document.querySelectorAll('.menu-list__disclosure[aria-expanded="true"]').forEach(function (btn) {
      if (exceptItem && exceptItem.contains(btn)) return;
      btn.click();
    });
  }

  document.addEventListener('click', function (event) {
    var item = event.target.closest('.menu-list__list-item');
    closeOpenSubmenus(item);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeOpenSubmenus(null);
  });
})();

/* Judge.me: tab "Product reviews" da an bang CSS, nhung Judge.me van dat no la tab
   ACTIVE mac dinh -> khung duoi hien "No items found". CSS khong doi duoc trang thai
   active (do JS cua widget quan ly), nen bam ho vao tab "Store reviews".
   Widget nap bat dong bo nen phai theo doi DOM thay vi chay mot lan. */
(function () {
  function activateShopTab() {
    var shop = document.querySelector('#jdgm-tab_shop_reviews');
    if (!shop) return false;
    if (shop.getAttribute('aria-selected') !== 'true') shop.click();
    return true;
  }

  if (activateShopTab()) return;

  var observer = new MutationObserver(function () {
    if (activateShopTab()) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Trang khong co widget (trang chu, policy...) thi thoi theo doi sau 20s
  setTimeout(function () { observer.disconnect(); }, 20000);
})();
